import React, { useEffect } from "react";
import "../css/AboutUs.css";

// Import images from assets
import SantoshImage from "../assets/images/Santosh_Gare_Image.jpg";
import KapilImage from "../assets/images/Kapil_Chopra_Image.png";

const AboutUs = () => {
  useEffect(() => {
    document.title = "AdvisorMitra.com - About Us";
  }, []);

  return (
    <div className="about-us">
      <div className="about-us-content">
        <h1>About Us</h1>

        <h2>Our Vision</h2>
        <p>
          We help financial professionals save time, engage clients more effectively, and grow their business through easy-to-use technology solutions.
        </p>

        <h2>What We Offer</h2>
        <p>
          * Simple Client Management – Keep all client details in one place.

          * Faster Data Processing – Turn hours of work into minutes.

          * Professional Reports – Deliver insights in a format clients love.
        </p>

        <h2>Who We Serve</h2>
        <p>
          Insurance Advisors, Mutual Fund Distributors, LIC Professionals, and Certified Financial Planners who want to work smarter and serve clients better.
        </p>

         <h2>Our Promise</h2>

        <p>
          We believe technology should be practical, affordable, and results-driven. That’s why we continuously enhance our tools to meet the evolving needs of our users.
        </p>
        
        
        
      </div>
    </div>
  );
};

export default AboutUs;
